if (!customElements.get('ac-trust-rotation')) {
  customElements.define('ac-trust-rotation', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      clearTimeout(this.timer);
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.slides = [...this.querySelectorAll('[data-message]')];
      this.mobile = matchMedia('(max-width: 749px)');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.index = 0;
      this.paused = Boolean(window.Shopify?.designMode);
      this.hovered = false;
      this.mobile.addEventListener('change', () => this.update(), options);
      this.motion.addEventListener('change', () => this.update(), options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => this.schedule(), options);
      this.addEventListener('focusout', () => queueMicrotask(() => this.schedule()), options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.addEventListener('animationend', event => {
        if (event.animationName === 'ac-trust-swipe-out') event.target.removeAttribute('data-leaving');
      }, options);
      this.update();
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.abortController?.abort();
    }

    select(index) {
      const previous = this.index;
      const animate = this.mobile.matches && !this.motion.matches && previous !== index;
      this.index = index;
      this.slides.forEach((slide, position) => {
        const inactive = this.mobile.matches && position !== index;
        slide.toggleAttribute('data-leaving', animate && position === previous);
        slide.toggleAttribute('data-current', position === index);
        slide.inert = inactive;
        if (inactive) slide.setAttribute('aria-hidden', 'true');
        else slide.removeAttribute('aria-hidden');
      });
    }

    update() {
      this.select(this.index);
      this.schedule();
    }

    schedule() {
      clearTimeout(this.timer);
      if (!this.isConnected || !this.mobile.matches || this.motion.matches || this.paused ||
          this.hovered || document.hidden || this.contains(document.activeElement)) return;
      this.timer = setTimeout(() => {
        this.select((this.index + 1) % this.slides.length);
        this.schedule();
      }, 4000);
    }
  });
}
